var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 16,
    height: 16,
    transform: "rotate(-180 16 16)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.67272L7.6497 5.31594C7.8442 5.12498 8.1558 5.12498 8.3503 5.31594L8 5.67272ZM4.35029 9.95678C4.15325 10.1502 3.83668 10.1473 3.64322 9.95029C3.44975 9.75325 3.45266 9.43668 3.6497 9.24321L4.35029 9.95678ZM12.3503 9.24322C12.5473 9.43668 12.5502 9.75325 12.3568 9.95029C12.1633 10.1473 11.8467 10.1502 11.6497 9.95678L12.3503 9.24322ZM8.3503 6.02951L4.35029 9.95678L3.6497 9.24321L7.6497 5.31594L8.3503 6.02951ZM8.3503 5.31594L12.3503 9.24322L11.6497 9.95678L7.6497 6.02951L8.3503 5.31594Z",
    fill: "#C0C9FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangearrow);
export default __webpack_public_path__ + "static/media/orangearrow.a1f37cd96af6f8b013a977a0a78ba5a5.svg";
export { ForwardRef as ReactComponent };